import React from 'react'

const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 58 69"
    className="design-iconfont"
    {...props}
  >
    <defs>
      <linearGradient x1="50%" y1="0%" x2="50%" y2="98.993%" id="c">
        <stop stopColor="#71ECDA" offset="0%" />
        <stop stopColor="#32B8C0" offset="100%" />
      </linearGradient>
      <linearGradient x1="50%" y1="0%" x2="50%" y2="100%" id="b">
        <stop stopColor="#98F3E7" offset="0%" />
        <stop stopColor="#66D0D5" offset="100%" />
      </linearGradient>
      <filter
        x="-44%"
        y="-37%"
        width="187.9%"
        height="173.9%"
        filterUnits="objectBoundingBox"
        id="a"
      >
        <feOffset dy={3} in="SourceAlpha" result="shadowOffsetOuter1" />
        <feGaussianBlur
          stdDeviation={5}
          in="shadowOffsetOuter1"
          result="shadowBlurOuter1"
        />
        <feColorMatrix
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.329116928 0"
          in="shadowBlurOuter1"
          result="shadowMatrixOuter1"
        />
        <feMerge>
          <feMergeNode in="shadowMatrixOuter1" />
          <feMergeNode in="SourceGraphic" />
        </feMerge>
      </filter>
    </defs>
    <g filter="url(#a)" fill="none" fillRule="evenodd">
      <path
        d="M28 4c6.35 0 12.1 2.59 16.261 6.774A23.132 23.132 0 0 1 51 27.136c0 5.526-3.422 12.305-7.652 18.275C37.784 53.26 30.73 60 28 60c-2.73 0-9.784-6.74-15.348-14.59C8.422 39.442 5 32.663 5 27.137c0-6.39 2.575-12.174 6.739-16.362C15.9 6.59 21.649 4 28 4Z"
        stroke="url(#b)"
        strokeWidth={2}
        fill="url(#c)"
      />
      <path
        d="M34.907 20.85h-1.171v-1.695c0-.691-.766-1.256-1.702-1.256h-8.068c-.936 0-1.702.565-1.702 1.256v1.695h-1.172c-1.69 0-3.074 1.343-3.074 2.984v11.158c0 1.64 1.384 2.984 3.074 2.984h13.815c1.691 0 3.075-1.343 3.075-2.984V23.834c0-1.64-1.384-2.984-3.075-2.984Zm-2.63 9.165c0 .55-.464.994-1.036.996h-1.465v1.406c-.002.55-.465.994-1.037.996H27.26c-.572-.002-1.036-.447-1.037-.996v-1.406h-1.466c-.571-.003-1.034-.447-1.036-.996v-1.419c.002-.549.465-.994 1.037-.995h1.466v-1.406c.001-.55.465-.994 1.037-.996h1.477c.572.002 1.035.447 1.037.996v1.407h1.465c.572.002 1.035.446 1.037.994v1.419Zm0-9.379h-8.555v-.988c0-.46.515-.837 1.143-.837h6.269c.629 0 1.143.377 1.143.837v.988Z"
        fill="#F7FFFF"
        fillRule="nonzero"
      />
    </g>
  </svg>
)

export default SvgComponent
